import type { IconData } from '@stacksjs/iconify-core'

export const fi1x1: IconData = {
  "body": "<path fill=\"#fff\" d=\"M0 0h512v512H0z\"/><path fill=\"#002f6c\" d=\"M0 186.2h512v139.6H0z\"/><path fill=\"#002f6c\" d=\"M123.2 0h139.6v512H123.1z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default fi1x1
